import { React, useEffect, useRef, useState } from "react";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import ProjectLogo from "./../images/project.png";
import TagLogo from "./../images/kubernetes.png";
import GcpProjectLogo from "./../images/GCP.png";
import TwoCardSlider from "./TwoCardSlider";
// import Tabs, { tabsClasses } from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import { Tabs, Tab } from "react-bootstrap";
import axios from "axios";
import { BsPlus, BsX } from "react-icons/bs";

const InitialDR = () => {
  const provider = localStorage.getItem("provider");

  const RESOURCE_GROUP_URL = `${
    process.env.REACT_APP_API_BASE_URL
  }/cloud/${provider?.toLowerCase()}/project-name-list`;

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [selectedValue, setSelectedValue] = useState("");
  // const [hoveredTab, setHoveredTab] = useState(null);
  const [tabTitle, setTabTitle] = useState("");

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };

  const [activeKey, setActiveKey] = useState("1");
  const [tabCounter, setTabCounter] = useState(2); // Keeps track of unique tab IDs
  const scrollContainerRef = useRef(null);
  const [tabs, setTabs] = useState([]);
  // eslint-disable-next-line
  const [selectedResourceGroup, setSelectedResourceGroup] = useState("");

  const fetchResourceGroupList = async () => {
    await axios.get(RESOURCE_GROUP_URL).then((res) => {
      console.log(res?.data?.data?.data, "resssss");
      const fetchedProjects = res?.data?.data?.data;
      const projectGroup = provider?.toLowerCase() === "azure" ? "az-fb-rg-DRD" : provider?.toLowerCase() === "aws" ? "drd-dev-1" : "DRD-Project";
      const indexFind = fetchedProjects?.findIndex(
        (project) => project.name === projectGroup
      );
      console.log(indexFind, "indexFind");

      // const defaultGroup = fetchedProjects?.[indexFind]?.projectName;
      const defaultGroup =
        indexFind !== -1
          ? fetchedProjects?.[indexFind]?.projectName
          : fetchedProjects?.[0]?.projectName;

      if (fetchedProjects?.length > 0) {
        const initialTab = {
          id: "1",
          title: defaultGroup || "Tag-Undefined",
          content: `This is the content of Tab 1.`,
        };
        setTabs([initialTab]);
        setTabTitle(defaultGroup || "Tag-Undefined");
        setSelectedResourceGroup(defaultGroup);
      }   
    });
  };

  useEffect(() => {
    fetchResourceGroupList();
    // eslint-disable-next-line
  }, []);

  // const scroll = (direction) => {
  //   if (scrollContainerRef.current) {
  //     const scrollAmount = 200; // Adjust the scroll amount as needed
  //     scrollContainerRef.current.scrollBy({
  //       left: direction === "left" ? -scrollAmount : scrollAmount,
  //       behavior: "smooth",
  //     });
  //   }
  // };
  const handleAddTab = () => {
    // Disable adding a new tab if activeKey is "4"
    if (tabs.length === 5) {
      alert("Adding a new tab is disabled when the active tab is 4.");
      return;
    }
    const newTabId = tabCounter;

    const newTab = {
      id: newTabId.toString(),
      title: tabTitle || "New Tab", // Duplicate the title of the first tab
      content: `This is the content of Tab ${tabs.length + 1}.`,
    };
    setTabs((prevTabs) => [...prevTabs, newTab]);
    console.log("newType", newTab.id);
    setActiveKey(newTab.id); // Set the new tab as active
    setTabCounter(tabCounter + 1); // Increment the counter
  };

  const handleRemoveTab = (tabId) => {
    const remainingTabs = tabs.filter((tab) => tab.id !== tabId);
    setTabs(remainingTabs);

    // Handle activeKey adjustment after removal
    if (activeKey === tabId && remainingTabs.length > 0) {
      setActiveKey(remainingTabs[0].id);
    }
  };
  console.log(tabs, "handleTab");

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader />

        <div className="px-4 mt-5 initiate-tab">
          <div className="mb-3" ref={scrollContainerRef}>
            <Tabs
              activeKey={activeKey}
              // onSelect={(key) => setActiveKey(Number(key))}
              onSelect={(key) => {
                // Ensure activeKey is not set to "add-tab"
                if (key !== "add-tab") setActiveKey(key);
              }}
              id="dynamic-tabs"
              className=""
            >
              {tabs.map((project, index) => (
                <Tab
                  eventKey={project.id}
                  key={project.id}
                  title={
                    <span
                      className="d-flex align-items-center"
                      // onMouseEnter={() => setHoveredTab(project.id)}
                      // onMouseLeave={() => setHoveredTab(null)}
                    >
                      <img
                        src={provider.toLowerCase() === 'azure' ? ProjectLogo : provider.toLowerCase() === 'aws' ? TagLogo : provider.toLowerCase() === 'gcp' ? GcpProjectLogo : ""}
                        alt="logo"
                        width={20}
                        height={20}
                        className="me-2"
                      ></img>{" "}
                      {project.title}
                      {tabs.length > 1 && (
                        <BsX
                          className="ms-2 fs-6"
                          style={{ cursor: "pointer", color: "black" }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent tab selection on close
                            handleRemoveTab(project.id);
                          }}
                        />
                      )}
                    </span>
                  }
                  tabClassName="custom-tab-item ms-2"
                >
                  <div className="card mt-6 rounded-lg border">
                    <TwoCardSlider
                      tabs={tabs}
                      setTabs={setTabs}
                      activeKey={activeKey}
                      setSelectedResourceGroup={setSelectedResourceGroup}
                      selectedValue={selectedValue}
                      setSelectedValue={setSelectedValue}
                      tabId={project?.id}
                    ></TwoCardSlider>
                  </div>
                </Tab>
              ))}
              <Tab
                eventKey="add-tab"
                tabClassName="w-40 h-40 rounded-circle webbg ms-2 d-flex justify-content-center align-items-center"
                title={
                  <span
                    onClick={handleAddTab}
                    className="pt-0"
                    style={{
                      cursor: tabs.length === 5 ? "not-allowed" : "pointer",
                      color: tabs.length === 5 ? "gray" : "inherit",
                    }}
                  >
                    <BsPlus color="white" size={30} />
                  </span>
                }
                disabled={tabs.length === 5}
              />
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default InitialDR;
